module.exports = __webpack_public_path__ + "img/116.1.0faa6fd9.jpg";